import React from 'react';
import { Link } from 'react-router-dom';
import pageHeaderBg from '../assets/images/page-header-bg.jpg';

function Blog() {
  return (
    <div className="blog-page">
      <section className="page-header parallaxie" style={{backgroundImage: `url(${pageHeaderBg})`}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">Our Blog</h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Our blog</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="page-blog">
        <div className="container">
          <div className="section-title" style={{marginBottom: '40px'}}>
            <div style={{marginBottom: '40px'}}></div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="post-item wow fadeInUp">
                <div className="post-featured-image">
                  <Link to="/blog/how-to-choose-mini-truck" data-cursor-text="View">
                    <figure className="image-anime">
                      <img src="/hellotruck-web-images/hello-truck-post-1.jpg" alt="How to Choose Mini Truck for Goods Transport" />
                    </figure>
                  </Link>
                </div>

                <div className="post-item-body">
                  <div className="post-item-content">
                    <h3><Link to="/blog/how-to-choose-mini-truck">How to Choose the Right Mini Truck for Your Goods Transport</Link></h3>
                    <p>Learn which vehicle—Tata Ace, Bolero Pickup, or Dost—is best for your goods. Complete guide for Coimbatore businesses and individuals.</p>
                  </div>

                  <div className="post-item-footer">
                    <div className="post-date">
                      <span>Jan 2025</span>
                    </div>
                    <div className="post-author">
                      <span>By HelloTruck Team</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="post-item wow fadeInUp" data-wow-delay="0.25s">
                <div className="post-featured-image">
                  <Link to="/blog/mini-truck-booking-coimbatore" data-cursor-text="View">
                    <figure className="image-anime">
                      <img src="/hellotruck-web-images/hello-truck-post-2.jpg" alt="Mini Truck Booking Coimbatore" />
                    </figure>
                  </Link>
                </div>

                <div className="post-item-body">
                  <div className="post-item-content">
                    <h3><Link to="/blog/mini-truck-booking-coimbatore">Mini Truck Booking in Coimbatore – Complete City Guide</Link></h3>
                    <p>Everything you need to know about booking mini trucks in Coimbatore. Areas covered, pricing, vehicle types, and booking process.</p>
                  </div>

                  <div className="post-item-footer">
                    <div className="post-date">
                      <span>Jan 2025</span>
                    </div>
                    <div className="post-author">
                      <span>By HelloTruck Team</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="post-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <Link to="/blog/mini-truck-booking-challenges-coimbatore" data-cursor-text="View">
                    <figure className="image-anime">
                      <img src="/hellotruck-web-images/tata-ace-hero.png" alt="Mini Truck Booking Challenges Coimbatore" />
                    </figure>
                  </Link>
                </div>

                <div className="post-item-body">
                  <div className="post-item-content">
                    <h3><Link to="/blog/mini-truck-booking-challenges-coimbatore">Challenges in Mini Truck Booking in Coimbatore – And How HelloTruck Solves Them</Link></h3>
                    <p>Real challenges people face while booking load vehicles in Coimbatore—and how HelloTruck is solving them step by step.</p>
                  </div>

                  <div className="post-item-footer">
                    <div className="post-date">
                      <span>2025</span>
                    </div>
                    <div className="post-author">
                      <span>By HelloTruck Team</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{background: '#f8f9fa', padding: '40px', borderRadius: '15px', marginTop: '50px', textAlign: 'center'}}>
            <h3 style={{color: '#E31E24', marginBottom: '15px'}}>Looking for a Mini Truck?</h3>
            <p style={{marginBottom: '20px', color: '#666'}}>Book your Tata Ace, Bolero Pickup, or Dost vehicle instantly with HelloTruck.</p>
            <a href="https://digital.hellotruck.in/login/user-login" target="_blank" rel="noopener noreferrer" className="btn-default">Book Now</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;
